<template>
  <main id="landing">
    <aside class="refine">
      <h2>Protocol Library</h2>
      <Categories></Categories>
      <CalloutDocs></CalloutDocs>
    </aside>
    <section class="landing">
      <h2 v-if="featuredProtocols.length > 0" id="featured">Featured Protocols</h2>
      <FeaturedProtocol v-for="protocol in featuredProtocols" :protocol="protocol"></FeaturedProtocol>
      <!-- <RecentlyAdded></RecentlyAdded> -->
    </section>
    
  </main>
</template>

<script>
  import Categories from './Categories'
  import FeaturedProtocol from './FeaturedProtocol'
  import RecentlyAdded from './RecentlyAdded'
  import CalloutDocs from './CalloutDocs'
  import db from '../store/db'

  export default {
    name: 'LandingView',
    components: {
      Categories,
      FeaturedProtocol,
      RecentlyAdded,
      CalloutDocs
    },
    data: function () {
      return {
        featuredProtocols: []
      }
    },
    created () {
      this.fetchFeaturedProtocols()
    },
    watch: {
      '$route': 'fetchFeaturedProtocols'
    },
    methods: {
      fetchFeaturedProtocols () {
        let that = this
        db.getFeaturedProtocols().then(
          (protocols) => {
            that.featuredProtocols = protocols
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LandingView.vue?068d1290